module.exports = __webpack_public_path__ + "static/media/Copy.89fa6e2b.svg";